import AntiphishingError from './AntiphishingError';
class EmailNotGivenByTheInvestor extends AntiphishingError {
    constructor(options) {
        super('The email address is required', options);
    }
}
export default EmailNotGivenByTheInvestor;
